export const NAVIGATION_DRAWER_TABLET_WIDTH = 200;
export const TASK_DRAWER_TABLET_WIDTH = 400;

export const NAVIGATION_DRAWER_WIDTH = 240;
export const TASK_DRAWER_WIDTH = 500;

export const JIRA_WIDGET_TARGET = "JSD widget";
